import { render, staticRenderFns } from "./localLifeMobile.vue?vue&type=template&id=08ec3226&scoped=true"
import script from "./localLifeMobile.vue?vue&type=script&lang=js"
export * from "./localLifeMobile.vue?vue&type=script&lang=js"
import style0 from "./localLifeMobile.vue?vue&type=style&index=0&id=08ec3226&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ec3226",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08ec3226')) {
      api.createRecord('08ec3226', component.options)
    } else {
      api.reload('08ec3226', component.options)
    }
    module.hot.accept("./localLifeMobile.vue?vue&type=template&id=08ec3226&scoped=true", function () {
      api.rerender('08ec3226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/localLifeMobile.vue"
export default component.exports